import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveUsers } from '../../../../features';

const useActiveUsers = ({
  page, accountId, packageId, isShareQuery, refreshUsers,
}) => {
  const { isShare, tenantId, accountOrgId } = isShareQuery || {};
  const [activeUsers, setActiveUsers] = useState({
    error: '',
    loading: true,
    dayData: {},
    weekObject: {},
    monthObject: {},
  });

  const dispatch = useDispatch();
  const activeUsersData = useSelector((state) => state.activeUsers);

  useEffect(() => {
    dispatch(getActiveUsers({
      page,
      ...(packageId && packageId !== '-all-' && { packageId }),
      ...(accountId && { accountId }),
      ...(isShareQuery && { ...isShareQuery }),
    }));
  }, [accountId, packageId, refreshUsers, isShare, tenantId, accountOrgId]);

  useEffect(() => {
    setActiveUsers({
      ...activeUsers,
      ...activeUsersData,
    });
  }, [activeUsersData]);

  return {
    error: activeUsers.error,
    loading: activeUsers.loading,
    dayData: activeUsers.dayObject || {},
    weekData: activeUsers.weekObject || {},
    monthData: activeUsers.monthObject || {},
  };
};

export default useActiveUsers;
